import {
  CoverPageOfferFragment,
  OfferAccessState,
  OfferKind
} from "@pathwright/graphql-client/src/generated"

export function getCoverPageOfferPosition(offer: CoverPageOfferFragment) {
  return offer.position || null
}

export function isPrivateCohortOffer(offer: CoverPageOfferFragment) {
  return offer.kind === OfferKind.CreateCohort
}

export function isCohortStoreOffer(offer: CoverPageOfferFragment) {
  return offer.kind === OfferKind.JoinCohort
}

/** Private Cohort Offers that still allow creating another group. */
export function offerAllowsCreateAnother(offer: CoverPageOfferFragment) {
  return (
    isPrivateCohortOffer(offer) &&
    offer.access.state === OfferAccessState.Available
  )
}

/**
 * Continue matching for an Offer card:
 * - Private Cohort: only RegistrationAccess created through this Offer's
 *   resource_license_offering_id (create-another when Available)
 * - Join Cohort / other: only RegistrationAccess for this Offer's cohort_id
 */
export function getOfferContinueOptions(offer: CoverPageOfferFragment) {
  if (isPrivateCohortOffer(offer)) {
    return {
      canCreateAnother: offerAllowsCreateAnother(offer),
      scopeToResourceLicenseOffering: true,
      resourceLicenseOfferingId: offer.resource_license_offering_id
    }
  }

  return {
    canCreateAnother: false,
    scopeToCohort: true,
    cohortId: offer.cohort_id
  }
}

// create_cohort offers without an explicit position are sorted to the end of the list.
export function sortCoverPageOffers(offers: CoverPageOfferFragment[]) {
  return [...offers].sort((firstOffer, secondOffer) => {
    const firstPosition = getCoverPageOfferPosition(firstOffer)
    const secondPosition = getCoverPageOfferPosition(secondOffer)

    if (firstPosition && secondPosition) {
      if (firstPosition < secondPosition) return -1
      if (firstPosition > secondPosition) return 1
      return 0
    }

    if (firstPosition) return -1
    if (secondPosition) return 1

    return 0
  })
}
